import { Breadcrumbs, Anchor, Text, Group, MantineStyleProps } from '@mantine/core';
import MENU from 'constant/menu';
import { useAppName } from 'contexts/AppProvider';
import React from 'react';

export interface BreadcrumbItem {
  title: string;
  href: string;
}

interface BreadcrumbsComponentProps extends MantineStyleProps {
  items: BreadcrumbItem[];
}

const BreadcrumbsComponent: React.FC<BreadcrumbsComponentProps> = ({ items, mb }) => {
  const { appName } = useAppName();
  const getIcons = (url?: string) => {
    if (!url) return null;

    const filteredMenu = MENU[appName].find((item) => item.url === url);

    if (filteredMenu && filteredMenu.icon) {
      const IconComponent = filteredMenu.icon;
      return <IconComponent />;
    }

    for (const menuItem of MENU[appName]) {
      const childItem = menuItem.children.find((child) => child.url === url);
      if (childItem && menuItem.icon) {
        const IconComponent = menuItem.icon;
        return <IconComponent color='dark' />;
      }
    }

    return null;
  };
  return (
    <Breadcrumbs mb={mb}>
      {items.map((item, index) => {
        if (!item.href) {
          return (
            <Text c={'grey.3'} fz={14} fw={600} key={index}>
              {item.title}
            </Text>
          );
        }
        return (
          <Anchor href={item.href} key={index}>
            <Group align='center' c={'secondary.7'} gap={2}>
              {getIcons(item.href as string)}
              <Text c={'secondary.7'} fz={14} fw={600}>
                {item.title}
              </Text>
            </Group>
          </Anchor>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsComponent;
